export default __webpack_public_path__ + "static/media/benefit_3.7ad5cdd5.png";